import { forwardRef, type Ref, type SVGProps } from "react";
const IconVideoCameraFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M30 22.8c0 1.1-.8 1.5-1.7 1l-2.6-1.6a4 4 0 0 1-1.7-3v-6.4a4 4 0 0 1 1.7-3l2.6-1.6c.9-.5 1.7-.1 1.7 1ZM3.6 7A1.6 1.6 0 0 0 2 8.6v14.8A1.6 1.6 0 0 0 3.6 25h16.8a1.6 1.6 0 0 0 1.6-1.6V8.6A1.6 1.6 0 0 0 20.4 7ZM12 20a4 4 0 1 1 4-4 4 4 0 0 1-4 4" /></svg>;
const ForwardRef = forwardRef(IconVideoCameraFilledSVG);
ForwardRef.displayName = "IconVideoCameraFilled";
export { ForwardRef as IconVideoCameraFilled };